import { Env } from '@stencil/core';

export interface Variables {
  StylesheetURL: string;
  QuestionsEndpoint: string;
  QuestionsEndpointNew: string;
  SnowplowContext: string;
  SnowplowRatingEvent: string;
  SnowplowFeedbackEvent: string;
  SnowplowCustomEvent: string;
  SnowplowCustomContext: string;
}

export const EnvConfigs: Variables = {
  StylesheetURL: Env.stylesheetURL,
  QuestionsEndpoint: Env.questionsEndpoint,
  QuestionsEndpointNew: Env.questionsEndpointNew,
  SnowplowContext: Env.snowplowContext,
  SnowplowRatingEvent: Env.snowplowRatingEvent,
  SnowplowFeedbackEvent: Env.snowplowFeedbackEvent,
  SnowplowCustomEvent: Env.snowplowCustomEvent,
  SnowplowCustomContext: Env.snowplowCustomContextEvent,
};

export const Version = Env.version;
export const BuildNumber = Env.buildNumber;
export const Stage = Env.stage;
